/**
 * External Imports
 */
import { useMemo, FC, Dispatch, SetStateAction, CSSProperties } from 'react';
import { connect } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuAvatar } from '@neutron/react';

/**
 * Internal Imports
 */
import { RootState } from '../../../../redux/store';

interface IModalSubHeaderProps {
  items?: string | string[];
  completed: boolean;
  type: string;
  view?: string;
  modalType: string;
  setView?: Dispatch<SetStateAction<'info' | 'search'>>;
}

const StopSubHeader: FC<IModalSubHeaderProps> = ({
  items,
  completed,
  type,
  view,
  modalType,
  setView
}) => {
  const styles = useMemo(
    () => ({
      customSubheaderLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 0 50%',
        cursor: 'pointer',
        fontSize: '0.875rem',
        fontWeight: 700,
        height: '100%'
      },
      blueColorBorderInfo: {
        borderBottom:
          view === 'info' ? '2px solid rgb(32, 117, 173, .75)' : 'none',
        color: view === 'info' ? '#2075AD' : '#6F6F6F',
        lineHeight: '44px'
      },
      blueColorBorderIssues: {
        borderBottom:
          view === 'search' ? '2px solid rgb(32, 117, 173, .75)' : 'none',
        color: view === 'search' ? '#2075AD' : '#6F6F6F',
        lineHeight: '44px'
      }
    }),
    [view]
  );

  return (
    <div
      id="modal-sub-header"
      className={`d-flex flex-row justify-content-${
        modalType === 'Edit Issue' ? 'start align-items-center' : 'around'
      } px-0 w-100 custom-subheader-container`}
    >
      <div
        role="link"
        tabIndex={0}
        style={{
          ...(styles.customSubheaderLabel as CSSProperties),
          ...(styles.blueColorBorderInfo as CSSProperties)
        }}
        onClick={() => (setView ? setView('info') : {})}
        onKeyDown={() => (setView ? setView('info') : {})}
      >
        <p className="my-auto">
          {type === 'stoplight' ? 'Stoplight' : 'Issue'} Information
        </p>
      </div>
      <div
        role="link"
        tabIndex={0}
        style={{
          ...(styles.customSubheaderLabel as CSSProperties),
          ...(styles.blueColorBorderIssues as CSSProperties)
        }}
        onClick={() => (setView ? setView('search') : {})}
        onKeyDown={() => (setView ? setView('info') : {})}
      >
        <span>
          {type === 'stoplight'
            ? items && (items.length > 0 || (completed && items.length === 0))
              ? 'Attached Issues'
              : 'Attach an Issue'
            : items || (completed && !items)
            ? 'Attached Stoplight'
            : 'Attach to Stoplight'}
        </span>
        {((type === 'stoplight' && items && items.length > 0) ||
          (type === 'issue' && items)) && (
          <NeuAvatar
            className="d-inline-flex ms-1"
            color="blue"
            initials={String(Array.isArray(items) ? items.length : 1)}
          />
        )}
      </div>
    </div>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    modalType: state.ModalReducer.modalType
  };
};

export default connect(mapReduxStateToProps)(StopSubHeader);
